// React
import React from "react";
// Domain
import { ListingTypes } from "office/reports/stats/StatsReport";
// Components
import DataBar from "common/ui/components/dataBar/DataBar";
import DataBarItem from "common/ui/components/dataBar/DataBarItem";
import GraphTwoSeries from "common/ui/components/graphs/GraphTwoSeries";
import StatsCard from "common/ui/containers/cards/StatsCard";
// Utils
import * as utils from "office/reports/stats/utils/utils";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class ListingViews extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let { listingType, viewsStats, fromDate, toDate } = this.props;
        return (React.createElement(StatsCard, null,
            React.createElement(DataBar, { label: "Views" },
                React.createElement(DataBarItem, { value: viewsStats.totalViewsGraph.summaryValue, description: utils.listingTypeViewLabels[listingType], toolTip: `Total views for ${ListingTypes[listingType]} listings in the given date range`, bold: true })),
            React.createElement(GraphTwoSeries, { title: "Total Views per day", vAxis1Label: "Total Views", fromDate: fromDate, toDate: toDate, seriesA: viewsStats.totalViewsGraph.series, seriesB: viewsStats.listingsCountGraph.series, colourSeriesA: viewsStats.totalViewsGraph.colour, colourSeriesB: viewsStats.listingsCountGraph.colour, labelSeriesA: "Views", labelSeriesB: "Listings" })));
    }
}
